module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isWeChat) ? _c('header', [_c('div', {
    staticClass: "header-contain"
  }, [_c('div', {
    staticClass: "header-middle"
  }, [_c('router-link', {
    staticClass: "fl logo",
    attrs: {
      "to": {
        path: '/'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [(_vm.language === 'ch') ? _c('span') : _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/main-page/nav_btn_logo@3x.png")
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showFirstMenu
      }),
      expression: "{ methods: showFirstMenu }"
    }],
    staticClass: "show-menu-img tap-box"
  }, [_c('img', {
    attrs: {
      "src": "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAwCAYAAABNPhkJAAAABGdBTUEAALGPC/xhBQAAATVJREFUaAXtmjESAUEQRQ2pROgIIjGBQCBxApbQERxCuQE5FyARCmxKrSrRphyAdK3/g6mSCWTdv6t+zeyK3htL9exUKqiyLBMkQwrEWpGJbAlZAyYjjBteOKgxgc8AbTuAJeKFwE9M6k6AX1WAZk5giZlxhfuYHJAa7xiuAmyDQEBAdzHMkRZiDZygN2QZQjhhVMmADMiADMiADMiADMiADMjAbwOxW2KH1EMsd0tHdEsF++EGQPdIB7FcKeCGBF5hMrNM+sW2JvAdN5pfNy1PH9zTclUE3jki3vn70eLq4jl287fk6NssVBmQARmQARmQARmQARmQgX8MxE08N0ce2A/7OtQCYB70sL5jGZ+ClCvs7mBaHvEdjDk38RYOQCPioorXD1tcTZAr8o6fGBrJRLYpWT+7UEMEgMF5qQAAAABJRU5ErkJggg=="
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.hideFirstMenu
      }),
      expression: "{ methods: hideFirstMenu }"
    }],
    staticClass: "hide-menu-img tap-box"
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/nav_btn_tab_close@3x.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-contain"
  }, [_c('ul', {
    staticClass: "first-menu"
  }, [_c('li', {
    staticClass: "first-item item clear"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggleSecondMenu
      }),
      expression: "{ methods: toggleSecondMenu }"
    }],
    staticClass: "text-contain"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v(_vm._s(_vm.$t("language.headerSolutions")))]), _vm._v(" "), _c('img', {
    staticClass: "fr trangle-img",
    attrs: {
      "src": require("assets/main-page/Chevron Copy@3x.png")
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "second-menu"
  }, [_c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/solutions/enterprise'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.enterprise")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/solutions/virtualNetwork'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.vn")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "space"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "first-item item clear"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggleSecondMenu
      }),
      expression: "{ methods: toggleSecondMenu }"
    }],
    staticClass: "text-contain"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v(_vm._s(_vm.$t("m.product")))]), _vm._v(" "), _c('img', {
    staticClass: "fr trangle-img",
    attrs: {
      "src": require("assets/main-page/Chevron Copy@3x.png")
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "second-menu"
  }, [_c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/product/connection'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.headerServicesConnection")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/product/delivery'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.headerServicesDelivery")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/product/global'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.headerServicesGlobal")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/product/mobility'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.mobility")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/services/device/R100-X6'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.device")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "space"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "first-item item clear"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggleSecondMenu
      }),
      expression: "{ methods: toggleSecondMenu }"
    }],
    staticClass: "text-contain"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v(_vm._s(_vm.$t("m.technology")))]), _vm._v(" "), _c('img', {
    staticClass: "fr trangle-img",
    attrs: {
      "src": require("assets/main-page/Chevron Copy@3x.png")
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "second-menu second-newMenu"
  }, [_c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/services/sdwan'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.headerServicesSd")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/technology/download'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.download")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/services/download'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.downloadHeader")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/free-trial'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.freeTitle")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/partner-apply'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.partner_title")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "space"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "first-item item clear"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggleSecondMenu
      }),
      expression: "{ methods: toggleSecondMenu }"
    }],
    staticClass: "text-contain"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v(_vm._s(_vm.$t("language.headerAbout")))]), _vm._v(" "), _c('img', {
    staticClass: "fr trangle-img",
    attrs: {
      "src": require("assets/main-page/Chevron Copy@3x.png")
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "second-menu company-menu"
  }, [_c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/about'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.aboutUs")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/expert'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.manage")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/award'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.awards")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/news'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.news")))])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "first-item item clear"
  }, [_c('div', {
    staticClass: "chang-language text-contain"
  }, [_c('img', {
    staticClass: "language-img",
    attrs: {
      "src": "data:image/gif;base64,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"
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.changeLanguage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.headerLanguage")))])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "show-avatar-img tap-box",
    attrs: {
      "href": "https://cc.oceanbluecloud.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/nav_btn_login.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4754649c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 113
// module chunks = 49